// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--Nn-Pe";
export var hero__background = "hero-module--hero__background--1d7Un";
export var hero__bottomGradient = "hero-module--hero__bottomGradient--+gG-n";
export var hero__container = "hero-module--hero__container--B2Ftj";
export var hero__title = "hero-module--hero__title--fS4gx";
export var hero__desc = "hero-module--hero__desc--wpV8E";
export var hero__media = "hero-module--hero__media--6w2j-";
export var hero__mediaWrapper = "hero-module--hero__mediaWrapper--z+Bg+";
export var hero__mediaImage = "hero-module--hero__mediaImage--k8U7L";
export var hero_vertical = "hero-module--hero_vertical--mYZ-N";
export var hero__button = "hero-module--hero__button--AOqDA";